import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/imgs/about-project-library.png")